import React from 'react';

import SignInPageView from './SignInPageView';
import useSignInPage from './useSignInPage';

export interface ISignInPageProps {
  page: 'sign-in' | 'logout';
}

const SignInPage = (props: ISignInPageProps) => {
  const state = useSignInPage();
  return <SignInPageView {...props} {...state} />;
};

export default SignInPage;
